import React from 'react';
import PropTypes from 'prop-types';

import PropTypeStatus from '../utilities/propTypes/PropTypeStatus';

const RewardsList = ({ rewards, header }) => (
  <div className="rewards-list">
    {header && <h3>{header}</h3>}
    {rewards.length > 0 && (
      <React.Fragment>
        <p>
          For security, the actual codes are not available. Refer to your downloaded CSV to identify
          them by #.
        </p>
        {rewards.map(reward => (
          <div className="reward" key={reward.rewardKey}>
            <span className="reward-number">{reward.rewardNumber}</span>
            <span className="code" title={`Refer to your CSV file under # ${reward.rewardNumber}`}>
              Refer to your CSV under # {reward.rewardNumber}
            </span>
          </div>
        ))}
      </React.Fragment>
    )}
    {rewards.length === 0 && <p>There are no claimed rewards.</p>}
  </div>
);

RewardsList.displayName = 'RewardsList';

RewardsList.defaultProps = {
  header: '',
};

RewardsList.propTypes = {
  rewards: PropTypes.arrayOf(PropTypes.shape({
    rewardNumber: PropTypes.number,
    rewardKey: PropTypes.string,
    ...PropTypeStatus,
  })).isRequired,
  header: PropTypes.string,
};

export default RewardsList;



// WEBPACK FOOTER //
// ./src/components/RewardsList.js